<div>
    <div class="flex head-schedules-list items-center px-0"
        [ngClass]="{'head-no-data': !schedules?.length}"
    >
        <div class="schedule-block header-title driver-name-container"
        [ngClass]="{
            'truck_list_name': filters?.subType !== 'Drivers'
        }"
        >
            <span class="header-cell-text">
                @if (filters?.subType == 'Drivers') {
                    Driver Name
                } @else {
                    Truck Name
                }
            </span>
            <button
                (click)="onUpdate.emit({dir: filters?.dir == 1 ? -1 : 1, sort: 'driverName'})"
                class="filter-sort-btn"
            >
                <i class="fa-solid text-gray-500"
                [ngClass]="{
                    'fa-chevron-down': (filters?.sort == 'driverName' && filters?.dir == -1) || filters?.sort !== 'driverName',
                    'fa-chevron-up': filters?.sort == 'driverName' && filters?.dir == 1
                    }"
                ></i>
            </button>
        </div>
        <div class="schedule-block header-title status-container">
            <span class="header-cell-text">Status</span>
            <button
                (click)="onUpdate.emit({dir: filters?.dir == 1 ? -1 : 1, sort: 'status'})"
                class="filter-sort-btn"
            >
                <i class="fa-solid text-gray-500"
                [ngClass]="{
                    'fa-chevron-down': (filters?.sort == 'status' && filters?.dir == -1) || filters?.sort !== 'status',
                    'fa-chevron-up': filters?.sort == 'status' && filters?.dir == 1
                    }"
                ></i>
            </button>
        </div>
        <div class="schedule-block header-title truck-container"
        [ngClass]="{
            'truck_list_truck': filters?.subType !== 'Drivers'
        }"
        >
                <span class="header-cell-text">
                    @if (filters?.subType == 'Drivers') {
                        Truck
                    } @else {
                        Driver
                    }
                </span>
                <button
                    (click)="onUpdate.emit({dir: filters?.dir == 1 ? -1 : 1, sort: 'unit'})"
                    class="filter-sort-btn"
                >
                    <i class="fa-solid text-gray-500"
                    [ngClass]="{
                        'fa-chevron-down': (filters?.sort == 'unit' && filters?.dir == -1) || filters?.sort !== 'unit',
                        'fa-chevron-up': filters?.sort == 'unit' && filters?.dir == 1
                        }"
                    ></i>
                </button>
        </div>
        <div class="schedule-block header-title request-date-container">
            <span class="header-cell-text">Request Date</span>
            <button
                (click)="onUpdate.emit({dir: filters?.dir == 1 ? -1 : 1, sort: 'reqDates'})"
                class="filter-sort-btn"
            >
                <i class="fa-solid text-gray-500"
                [ngClass]="{
                    'fa-chevron-down': (filters?.sort == 'reqDates' && filters?.dir == -1) || filters?.sort !== 'reqDates',
                    'fa-chevron-up': filters?.sort == 'reqDates' && filters?.dir == 1
                    }"
                ></i>
            </button>
        </div>
        <div class="schedule-block header-title dispatcher-requested-container">
            <span class="header-cell-text">Dispatcher Requested</span>
            <button
                (click)="onUpdate.emit({dir: filters?.dir == 1 ? -1 : 1, sort: 'dispatchName'})"
                class="filter-sort-btn"
            >
                <i class="fa-solid text-gray-500"
                [ngClass]="{
                    'fa-chevron-down': (filters?.sort == 'dispatchName' && filters?.dir == -1) || filters?.sort !== 'dispatchName',
                    'fa-chevron-up': filters?.sort == 'dispatchName' && filters?.dir == 1
                    }"
                ></i>
            </button>
        </div>
        <div class="schedule-block header-title trip-name-container">
            <span class="header-cell-text">Trip Name</span>
            <button
                (click)="onUpdate.emit({dir: filters?.dir == 1 ? -1 : 1, sort: 'tripName'})"
                class="filter-sort-btn"
            >
                <i class="fa-solid text-gray-500"
                [ngClass]="{
                    'fa-chevron-down': (filters?.sort == 'tripName' && filters?.dir == -1) || filters?.sort !== 'tripName',
                    'fa-chevron-up': filters?.sort == 'tripName' && filters?.dir == 1
                    }"
                ></i>
            </button>
        </div>
        <div class="schedule-block header-title view-request-container">
        </div>
    </div>
    <div>
        @for (schedule of schedules; track $index) {
            <div class="flex main-schedules-item items-center px-0">
                <div class="schedule-block driver-name-container"
                    [ngClass]="{
                        'truck_list_name': filters?.subType !== 'Drivers'
                    }"
                >
                    @if (filters?.subType == 'Drivers') {
                        <span class="driver_name">{{schedule?.driver?.name}}</span>
                    } @else {
                        <span class="driver_name">                            
                            {{schedule?.unit?.name}}
                        </span>
                    }
                </div>
                <div class="schedule-block status-container">
                    <span class="status rounded-md"
                        [ngClass]="{
                            'picked_up_status': schedule?.status == 'PENDING',
                            'bg-blue-100 text-blue-900': schedule?.status == 'APPROVED',
                            'canceled_status': schedule?.status == 'DECLINED'
                        }"
                    >{{schedule?.status}}</span>
                    <p class="trip_type">{{schedule?.type == 'DAY_OFF' ? 'Day Off' : 'Trip'}}</p>
                </div>
                <div class="schedule-block truck-container"
                    [ngClass]="{
                        'truck_list_truck': filters?.subType !== 'Drivers'
                    }"
                >
                    @if (schedule?.type !== 'DAY_OFF' && schedule?.unit) {

                        @if (filters?.subType == 'Drivers') {
                            <span class="unit">
                                <i class="fa-solid fa-truck text-gray-500"></i>
                                {{schedule?.unit?.name}}
                            </span>
                        } @else {
                            <span class="unit">
                                {{schedule?.driver?.name}}
                            </span>
                        }
                    }
                </div>
                <div class="schedule-block request-date-container">
                    <span class="date">
                        <span class="startDate">{{schedule.startDate| date: 'MM/dd/yy' : 'UTC'}}</span>
                            <div class="date_lines">
                                <div class="date_line"></div>
                                <div class="date_line"></div>
                                <div class="date_line"></div>
                                <div class="date_line"></div>
                                <div class="date_line"></div>
                            </div>
                        <span class="endDate">{{schedule.endDate| date: 'MM/dd/yy' : 'UTC'}}</span>
                    </span>
                </div>
                <div class="schedule-block dispatcher-requested-container">
                    <span class="dispatch_name">{{schedule?.dispatcher?.name}}</span>
                </div>
                <div class="schedule-block trip-name-container">
                    @if (schedule?.type !== 'DAY_OFF' && schedule?.tripId) {
                        <a class="trip_name" [routerLink]="['/', userIndex, 'trips', $safeNavigationMigration(schedule?.tripId)]">{{schedule?._local?.trip?.tripName}}</a>
                    }
                </div>
                <div class="schedule-block view-request-container">
                    <button class="view_request" (click)="openViewRequest(schedule)">View Request</button>
                </div>
            </div>
        }
    </div>
    <div class="pb-3">
        <app-pagination
          *ngIf="schedules?.length"
          (pageChange)="onPage.emit({page: $event, limit: limit})"
          [total]="total"
          [limit]="limit"
          [options]="{white: true}"
          [currentPage]="filters?.page || 1"
        ></app-pagination>
      </div>
</div>